/* Pure Desi — premium layer v2, 2026-09-19.
   Loaded deferred from layout/theme.liquid.
   Styles: block (8) and block (10) in assets/pd-diwali-fixes.css.
   PROGRESSIVE: each part is wrapped; if any of it fails, the page works exactly as it did.
   It never changes any element's behaviour: no attribute is set or cleared, nothing is
   submitted, no gating is altered. v2 adds parts 3 and 4, which only ADD COSMETIC CLASSES.
   v2 note on scope: part 3a listens to the terms checkbox's own `change` event and part 3
   adds a class to the checkout button. It does not tick, untick, enable, disable or submit
   anything. The Bird widget and the cart form are untouched. */
(function(){
  'use strict';
  var d=document;
  function ready(fn){ if(d.readyState==='loading') d.addEventListener('DOMContentLoaded',fn); else fn(); }

  /* 1. PRODUCT PAGE: "What's inside" starts open. pd-ux.js builds that <details> after load, so
        watch for it briefly, open it ONCE, then stop. A shopper who closes it keeps it closed. */
  function whatsInside(){
    var b=d.body; if(!b||!b.classList.contains('template-product')) return;
    var done=false;
    function go(){ if(done) return true; var el=d.querySelector('details.pd-wi-inline'); if(el){ done=true; el.open=true; } return done; }
    if(go()||!window.MutationObserver) return;
    var mo=new MutationObserver(function(){ if(go()) mo.disconnect(); });
    mo.observe(b,{childList:true,subtree:true});
    setTimeout(function(){ mo.disconnect(); },6000);
  }

  /* 2. CART PAGE: the gift note previews the real slip.
        Wording checked against the dispatch system on 2026-09-18: the customer slip prints the
        order note under "A message with your order" in Instrument Serif and carries no prices. */
  function slip(){
    var b=d.body; if(!b||!b.classList.contains('template-cart')) return;
    var wrap=d.querySelector('#AjaxCartSubtotal .cart__instructions.pd-gift-note:not(.pd-order-note)');
    if(!wrap||wrap.querySelector('.pd-slip')) return;
    var det=wrap.querySelector('details'), ta=wrap.querySelector('textarea[name="note"]'), host=wrap.querySelector('cart-note')||ta;
    if(!det||!ta||!host) return;
    /* CF4 (2026-09-25, Abhi: shorter phone cart): phones keep the note as a one-tap row unless a note is
       already written; wider screens still open it. The slip preview is built either way and shows on open. */
    if(ta.value||!(window.matchMedia&&window.matchMedia('(max-width:767px)').matches)) det.open=true;
    var s=d.createElement('div'); s.className='pd-slip';
    s.innerHTML='<p class="pd-slip__lbl">A message with your order</p><p class="pd-slip__msg" aria-live="polite"></p>'
               +'<p class="pd-slip__fine">Printed once, on one slip with your order. The slip never shows prices.</p>';
    host.insertAdjacentElement('afterend',s);
    var msg=s.querySelector('.pd-slip__msg');
    function paint(){ var v=(ta.value||'').replace(/^\s+|\s+$/g,''); msg.textContent=v||'Your message will appear here, as it prints.'; msg.classList.toggle('is-empty',!v); }
    ta.addEventListener('input',paint); paint();
  }
  function watchCart(){
    var b=d.body; if(!b||!b.classList.contains('template-cart')||!window.MutationObserver) return;
    var box=d.getElementById('AjaxCartSubtotal'); if(!box) return;
    var t=0; new MutationObserver(function(){ clearTimeout(t); t=setTimeout(function(){ try{ slip(); }catch(_){} },60); }).observe(box,{childList:true,subtree:false});
  }


  /* 3. THE CART CTAs SHEEN ONCE, at the moment they mean something. Styles: block (10).
        [CTA-SHEEN] otherwise loops every 14s, so the instant checkout becomes possible is
        silent and the light then keeps moving for no reason. Block (10) kills the loop on
        these two buttons; this fires a single pass instead.
        EVERY SELECTOR AND SIGNAL BELOW WAS MEASURED ON THE LIVE SITE 19 Sep — see the
        three "verified" notes. Do not "tidy" them back to the obvious guess. */
  function sheenOnce(el){
    if(!el||el.hasAttribute('disabled')) return;
    el.classList.remove('pd-sheen-once');
    void el.offsetWidth;                        /* force a reflow so it can re-fire */
    el.classList.add('pd-sheen-once');
    setTimeout(function(){ el.classList.remove('pd-sheen-once'); },1800);
  }
  /* 3a. /cart — the checkout button is NEVER `disabled` here; the gate is HTML5 `required`
         on the terms box plus a submit-time error. So the moment the shopper becomes able to
         check out is the box being ticked. VERIFIED: #CheckOut has no disabled attribute on
         load, and the box is #AgreeToTos-page, not #AgreeToTos (that id is the drawer's). */
  function watchTerms(){
    var b=d.body; if(!b||!b.classList.contains('template-cart')) return;
    var box=d.querySelector('terms-checkbox input[type="checkbox"]');
    var btn=d.getElementById('CheckOut');
    if(!box||!btn) return;
    box.addEventListener('change',function(){ if(box.checked) sheenOnce(btn); });
  }
  /* 3b. drawer — VERIFIED: on open the theme REMOVES aria-hidden rather than setting it to
         "false", so watch the `sidebar--opened` class instead. 260ms lets the panel settle. */
  function watchDrawer(){
    if(!window.MutationObserver) return;
    var dr=d.getElementById('site-cart-sidebar'); if(!dr) return;
    var open=dr.classList.contains('sidebar--opened');
    new MutationObserver(function(){
      var now=dr.classList.contains('sidebar--opened');
      if(!open&&now&&!dr.classList.contains('cart-is-empty')){
        setTimeout(function(){ try{ sheenOnce(d.getElementById('ViewCart')); }catch(_){} },260);
      }
      open=now;
    }).observe(dr,{attributes:true,attributeFilter:['class']});
  }

  /* 4. THE BAG ANSWERS AN ADD. Only on an INCREASE, so removing an item does not bounce.
        Observes each count's stable ANCESTOR with subtree, not the count node itself: if the
        theme re-renders and replaces that node, an observer bound to the node would die. */
  function watchBag(){
    if(!window.MutationObserver) return;
    var seen=[];
    [].slice.call(d.querySelectorAll('[data-header-cart-count]')).forEach(function(el){
      var host=el.closest('a,button')||el.parentElement;
      if(!host||seen.indexOf(host)>-1) return;
      seen.push(host);
      var last=(el.textContent||'').trim();
      new MutationObserver(function(){
        var cur=host.querySelector('[data-header-cart-count]'); if(!cur) return;
        var now=(cur.textContent||'').trim();
        if(now!==last&&(parseInt(now,10)||0)>(parseInt(last,10)||0)){
          cur.classList.remove('pd-bump'); void cur.offsetWidth; cur.classList.add('pd-bump');
          setTimeout(function(){ cur.classList.remove('pd-bump'); },400);
        }
        last=now;
      }).observe(host,{childList:true,subtree:true,characterData:true});
    });
  }

  ready(function(){
    try{ whatsInside(); }catch(_){}
    try{ slip(); watchCart(); }catch(_){}
    try{ watchTerms(); }catch(_){}
    try{ watchDrawer(); }catch(_){}
    try{ watchBag(); }catch(_){}
  });
})();
